export default __webpack_public_path__ + "static/media/thumbnail.f234bc83.jpg";